import React from 'react'

const RightArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16" fill="none">
    <path d="M10.2089 8.18558L2.47633 0.92653L0.0572911 3.50581L5.21231 8.344L0.374122 13.499L2.95169 15.9199L10.2107 8.18552L10.2089 8.18558Z" fill="#777777"/>
    </svg>
  )
}

export default RightArrow